/**
 * financialClearance route path constants.
 *
 * Mirrors `modules/agents/routes/routeConfig.ts`: all financial-clearance paths are declared here so
 * App routing, in-app navigation, and path builders share one source of truth.
 */
export const FINANCIAL_CLEARANCE_BASE_PATH = '/financial-clearance';
export const FC_DASHBOARD_PATH = '/financial-clearance/dashboard';
export const FC_WORKLIST_ROUTE_PATH = '/financial-clearance/worklist/:type';
export const FC_WORKLIST_PATH_TEMPLATE = '/financial-clearance/worklist/:type';
export const FC_AGENT_DASHBOARD_PATH = '/financial-clearance/agent-dashboard';
export const FC_ASSIGNMENT_MANAGEMENT_PATH = '/financial-clearance/assignment-management';
export const FC_VERIFICATION_DETAIL_ROUTE_PATH = '/financial-clearance/verification/:id';
export const FC_VERIFICATION_DETAIL_PATH_TEMPLATE = '/financial-clearance/verification/:id';
export const FC_SEARCH_PATH = '/financial-clearance/search';
export const FC_PREQUOTES_PATH = '/financial-clearance/pre-quotes';
export const FC_PREQUOTE_DETAIL_ROUTE_PATH = '/financial-clearance/pre-quotes/:id';
export const FC_PREQUOTE_DETAIL_PATH_TEMPLATE = '/financial-clearance/pre-quotes/:id';
